import CompanyModal from './CompanyModal';

export default CompanyModal;
